import React from "react";
import GoogleMapProvider from "./GoogleMapProvider";
import OSMMapProvider from "./OSMMapProvider";
import { MAP_PROVIDERS } from "./mapProviderUtils";

export default function MapProviderRenderer({ provider, ...props }) {
  if (provider === MAP_PROVIDERS.OSM) {
    return <OSMMapProvider {...props} />;
  }
  return <GoogleMapProvider {...props} />;
}
